<script setup>
import {onMounted, ref} from 'vue';
import {Dialog, DialogPanel, DialogTitle, TransitionRoot} from '@headlessui/vue';
import {useI18n} from 'vue-i18n';
import {visibleAMLQuestionnaireResultKeys} from '@/services/AmlQuestionnaireService';

const {t} = useI18n();
const props = defineProps({
  results: {type: Object, required: false},
});

const emit = defineEmits(['confirm', 'cancel']);
const isOpen = ref(true);

const result = ref(null);

const closeModalWith = (value) => {
  isOpen.value = false;
  setTimeout(() => {
    if (value === 'confirm') {
      emit('confirm');
    } else {
      emit('cancel');
    }
  }, 300);
};

onMounted(() => {
  if (props.results) {
    result.value = props.results;
  }
});

</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-lg" style="z-index: 1055">
        <div class="modal-content">
          <DialogPanel class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <DialogTitle as="h3" class="modal-title">
                {{ t('AmlQuestionnaireModal.result') }}
              </DialogTitle>
              <i class="btn-close cursor-pointer" @click="closeModalWith('cancel')" aria-label="Close"></i>
            </div>
            <div class="row mb-3">
              <div class="col-12">
                <br/>
                <fieldset>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">{{ t('AmlQuestionnaireModal.metric') }}</th>
                        <th scope="col">{{ t('AmlQuestionnaireModal.review') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="key in visibleAMLQuestionnaireResultKeys">
                        <td scope="row" :class="{ 'fw-bold': key === 'CLIENT_CHECK_INTENSITY' }">{{ t('AmlQuestionnaireModal.' + key) }}</td>
                        <td>{{ result?.[key] || '-' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </fieldset>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-link text-decoration-underline text-dark" type="button" @click="closeModalWith('cancel')">{{ t('AmlQuestionnaireModal.cancel') }}</button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
